(function ($) {
  $.fn.focusFirstInput = function () {
    return this.each(function () {
      $(this)
        .find('input[type=text], input[type=email], textarea')
        .filter(':visible:enabled:first')
        .focus();
    });
  };
}(jQuery));



// WEBPACK FOOTER //
// ./javascripts/components/legacy/jquery.focusFirstInput.js